import { Button, Classes, Dialog } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import classNames from "classnames";
import { Observer } from "mobx-react";
import React from "react";
import GridView from "./types/GridView";
import { GridBaseSettings } from "../../types/GridBaseSettings";
import GridViewConfiguration from "./GridViewConfiguration";
import GridColumn from "../../../GridColumns/GridColumn";
import GridViewReadDTO from "./types/GridViewReadDTO";
import GridViewsSingleSelect from "../../../GridViewsSingleSelect/GridViewsSingleSelect";

export interface GridViewPickerComponentProps {
  currentGridView: GridView;
  gridBaseSettings: GridBaseSettings;

  getGridView: (viewId: string) => GridView;
  updateViewColumnSettings: (
    viewId: string,
    columnsConfiguration: string[]
  ) => Promise<void>;
  showUserDefaultView?: boolean;
  setDefaultView?: (id: string) => Promise<void>;
  baseGridColumnsConfiguration: GridColumn[] | undefined;
  getAuthRequestHeader?: () => Promise<Record<string, string>>;
  odataUrl?: string;
  userId?: string;
  userGridViews?: GridViewReadDTO[];
  assignCurrentGridView?: (
    id: string,
    gridColumnsConfiguration: GridColumn[] | undefined,
    gridViews: GridViewReadDTO[]
  ) => void;
}
const GridViewPickerComponent: React.FC<GridViewPickerComponentProps> = (
  props
) => {
  const [isPickerDialogOpen, setIsPickerDialogOpen] =
    React.useState<boolean>(false);

  const closeDialog = () => {
    setIsPickerDialogOpen(false);
  };
  return (
    <Observer>
      {() => {
        return (
          <section
            className={classNames("ucl-grid-views-picker", {
              ready: props.currentGridView,
            })}
          >
            <>
              <div className="ucl-grid-views-picker-config">
                {props.userGridViews && (
                  <GridViewsSingleSelect
                    gridViewOptions={props.userGridViews.map((view) => ({
                      label: view.title,
                      value: view.id,
                      isDefault: view.isDefault,
                    }))}
                    value={props.currentGridView.id}
                    showUserDefaultView={props.showUserDefaultView}
                    setDefaultView={props.setDefaultView}
                    onSubmit={(value) =>
                      props.assignCurrentGridView &&
                      value &&
                      props.userGridViews &&
                      props.assignCurrentGridView(
                        value as string,
                        props.baseGridColumnsConfiguration,
                        props.userGridViews
                      )
                    }
                  />
                )}
                <Button
                  title="Board View Configuration"
                  minimal={true}
                  icon={IconNames.COG}
                  disabled={!props.currentGridView}
                  onClick={() => {
                    !!props.currentGridView && setIsPickerDialogOpen(true);
                  }}
                >
                  <span
                    className={classNames({
                      "bp5-skeleton": !props.currentGridView,
                    })}
                  >{`${
                    props.gridBaseSettings?.title ?? ""
                  } View Configuration`}</span>
                </Button>
              </div>
              {props.currentGridView && (
                <div className="ucl-grid-views-picker-dialog">
                  <Dialog
                    isOpen={isPickerDialogOpen}
                    canEscapeKeyClose={false}
                    canOutsideClickClose={false}
                    portalClassName="ucl-grid-views-picker-dialog"
                    title={`${props.gridBaseSettings?.title} View Configuration`}
                    isCloseButtonShown={true}
                    onClose={() => closeDialog()}
                  >
                    <div className={Classes.DIALOG_BODY}>
                      <GridViewConfiguration
                        viewId={props.currentGridView.id}
                        getGridView={props.getGridView}
                        updateViewColumnSettings={
                          props.updateViewColumnSettings
                        }
                        baseGridColumnsConfiguration={
                          props.baseGridColumnsConfiguration
                        }
                        onCancel={closeDialog}
                        onSubmit={closeDialog}
                      />
                    </div>
                  </Dialog>
                </div>
              )}
            </>
          </section>
        );
      }}
    </Observer>
  );
};

const GridViewPicker = GridViewPickerComponent;
export default GridViewPicker;
